import api from "../utils/axios";

export async function getHomeNavbar() {
    const response = await api.get(`/home/navbar`);

    return response.data?.data || [];
}